var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":_vm.isUcm ? 'inspire' : _vm.isTnk ? 'wisata' : 'bangsal'}},[_c(_vm.layout,{tag:"component"}),_c('toast',{ref:"toast"}),_c('confirmation',{ref:"confirm"}),_c('popup-notifikasi',{ref:"notifikasi"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }